import { OutlinedTextFieldProps, TextField } from '@mui/material';
import React, { useCallback } from 'react';

/**
 * Extend properties
 */
export interface RegexProps extends OutlinedTextFieldProps {
  regex: RegExp;
  changeHandler: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const RegexTextField: React.FunctionComponent<RegexProps> = (props) => {
  const { regex, changeHandler, ...rest } = props;

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      e.currentTarget.value = e.currentTarget.value.replace(regex, '');
      changeHandler(e);
    },
    [regex, changeHandler]
  );

  return <TextField onChange={handleChange} {...rest} />;
};

export default RegexTextField;
